module.exports = __webpack_public_path__ + "static/img/zhaopin.ab320e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/zhaopin.png
// module id = i/D2
// module chunks = 1